<template>
  <div class="availability" :class="{ compact }">
    <BaseButton
      v-if="disabled"
      kind="auxiliary"
      state="disabled"
      type="secondary"
      :text="label"
    >
      <template #icon>
        <BusyIcon class="busy-icon" />
      </template>
    </BaseButton>
    <ButtonMenu v-else :offset="[0, 4]" placement="bottom-start">
      <template #btn>
        <BaseButton kind="auxiliary" type="secondary" :text="label">
          <template #icon>
            <BusyIcon class="busy-icon" />
          </template>
        </BaseButton>
      </template>
      <template #content>
        <BaseButton
          class="full"
          kind="auxiliary"
          text="Busy"
          :is-expanded="true"
          :state="value === 'busy' ? 'selected' : 'default'"
          @click="set('busy')"
        />
        <BaseButton
          class="full"
          kind="auxiliary"
          text="Free"
          :is-expanded="true"
          :state="value === 'free' ? 'selected' : 'default'"
          @click="set('free')"
        />
      </template>
    </ButtonMenu>
  </div>
</template>

<script lang="ts">
import { capitalize } from "lodash";
import { computed, defineComponent, PropType, toRefs } from "vue";

import type { EventAvailability } from "@ctrl/controller-rpc";

import BaseButton from "@/components/base/BaseButton.vue";
import ButtonMenu from "@/components/elements/ButtonMenu.vue";
import BusyIcon from "@/components/icons/BusyIcon.vue";

export default defineComponent({
  components: { BusyIcon, ButtonMenu, BaseButton },
  props: {
    compact: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    value: {
      type: String as PropType<EventAvailability>,
      default: "busy",
    },
  },
  emits: {
    "update:value": (_: EventAvailability) => true,
  },
  setup(props, { emit }) {
    const { value } = toRefs(props);
    const label = computed<string>(() => capitalize(value.value));
    const set = (v: EventAvailability) => emit("update:value", v);
    return { label, set };
  },
});
</script>

<style scoped lang="scss">
.availability {
  display: flex;
  flex-direction: column;

  .busy-icon {
    width: 12px;
    height: 12px;
  }
}
</style>
